export const validateCompany = (company) => {
	let errors = {};

	// Validación de Información de la Empresa
	if (!company.companyName)
		{errors.companyName = "El campo Razón Social es obligatorio."};

	if (!company.nacionality)
		{errors.nacionality = "El campo Nacionalidad es obligatorio."};

	if (!company.cuit) {
		errors.cuit = "El campo CUIT es obligatorio.";
	} else if (company.cuit.length !== 11) {
		errors.cuit = "El campo CUIT debe tener 11 dígitos.";
	}

	if (!company.age){
		errors.age = "El campo Años de la Empresa es obligatorio.";}

	if (!company.street){errors.street = "El campo Calle es obligatorio."};

	if (!company.numberStreet){
		errors.numberStreet = "El campo Número es obligatorio."};

	if (!company.postalCode){
		errors.postalCode = "El campo Código Postal es obligatorio."};

	if (!company.location){
		errors.location = "El campo Localidad es obligatorio."};

	if (!company.province){
		errors.province = "El campo Provincia es obligatorio."};

	if (!company.codeOfWorkActivity){
		errors.codeOfWorkActivity =
			"El campo Código de Actividad Laboral es obligatorio."};

	if (!company.ActivityBeingCarriedOut){
		errors.ActivityBeingCarriedOut =
			"El campo Actividad de la Empresa es obligatorio."};
	return errors;
};

export const validateEconomicInformation = (economicInfo) => {
	let errors = {};

	if (!economicInfo.IncomeOfLegalPerson) {
		errors.IncomeOfLegalPerson =
			"El campo Monto Transaccional Anual es obligatorio.";
	}

	if (!economicInfo.total_indebtedness_of_the_financial_system) {
		errors.total_indebtedness_of_the_financial_system =
			"El campo Total de endeudamiento del sistema financiero es obligatorio.";
	}

	if (!economicInfo.total_monthly_commitment_of_the_financial_system) {
		errors.total_monthly_commitment_of_the_financial_system =
			"El campo Total de compromiso mensual sistema financiero es obligatorio.";
	}

	if (!economicInfo.current_status_with_BCRA) {
		errors.current_status_with_BCRA =
			"El campo Situación vigente ante BCRA es obligatorio.";
	}

	return errors;
};

export const validateRelationshipWithMutual = (relationshipInfo) => {
	let errors = {};

	if (!relationshipInfo.relation) {
		errors.relation = "El campo Tipo de relación es obligatorio.";
	}

	if (!relationshipInfo.canal) {
		errors.canal = "El campo Canal es obligatorio.";
	}

	return errors;
};

export const validatePoliticalInformation = (politicalInfo) => {
	let errors = {};

	if (!politicalInfo.politicallyExposed) {
		errors.politicallyExposed =
			"El campo Es políticamente expuesto es obligatorio.";
	}

	return errors;
};